import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import moment from "moment-timezone";

import { addData, getAllData } from "../../Utility/API";
import { endPoints } from "../../constant/Environment";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import MiniStat from "../../components/MiniStat";
import { tokens } from "../../theme";
import { mono, pill, statusKind, FactRows } from "../../components/tableKit";
import { sumSC_credit_SC_Main } from "../../Utility/functions/Helper";

const userTypeLabel = (t) =>
  t == -1 ? "VISITOR" : t == 0 ? "FINANCIAL" : t == 1 ? "TRADER" : t == 2 ? "USER" : t == 3 ? "OPERATOR" : t == 4 ? "AGENCY" : "";

const radioSx = { "& .MuiFormControlLabel-label": { fontSize: 13 } };
const groupLabelSx = { fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, color: tokens.textDim, "&.Mui-focused": { color: tokens.textDim } };

const Transfer = () => {
  const [isLoading, setIsLoadinig] = useState(false);
  const [admin, setAdmin] = useState({});
  const [riskmng, setRiskMng] = useState({});
  const [allusers, setAllusers] = useState([]);
  const [showother, setShowOther] = useState(false);
  const [selected, setSelected] = useState({});
  const [amountEnter, setAmountEnter] = useState("");
  const [type, setType] = useState("gc_balance");
  const [searchQuery, setSearchQuery] = useState("");
  const [description, setDescription] = useState("");
  const [requestType, setRequestType] = useState("Deposit");

  useEffect(() => {
    getAll();
  }, []);

  const getAll = () => {
    let url1 = endPoints.api.GET_ADMIN;
    let url2 = endPoints.api.GET_RISKMANAGER;
    let url3 = endPoints.api.GET_ALL_USERS;
    setIsLoadinig(true);
    Promise.all([getAllData(url1), getAllData(url2), getAllData(url3)])
      .then((response) => {
        setIsLoadinig(false);
        setAdmin(response[0]?.data);
        let result2 = response[1]?.data;
        setRiskMng(result2);
        setSelected(result2);
        setAllusers(response[2]?.data || []);
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
  };

  const handleAmountChange = (event) => {
    let value = event.target.value.replace(/[^0-9.]/g, "");
    setAmountEnter(value);
  };

  const WithdrawDeposit = () => {
    if (amountEnter !== "" && type !== "" && requestType !== "") {
      let data = {
        userId: selected?.idUser,
        coinType: type,
        transferType: requestType,
        amount: amountEnter,
        description: description,
        hideUserTrans: false,
      };

      let url = endPoints.api.DEPOSIT_COIN;
      let url1 = endPoints.api.WITHDRAW_COIN;
      setIsLoadinig(true);
      addData(requestType === "Deposit" ? url : url1, data)
        .then((response) => {
          setIsLoadinig(false);
          if (response.data.status === "success") {
            requestType === "Deposit"
              ? SuccesToast("Coins Deposit Succesfully")
              : SuccesToast("Coins Withdrawn Succesfully");
            setAmountEnter("");
            setDescription("");
            onUserClick(selected);
          } else {
            ErrorToast(response?.data.message);
          }
        })
        .catch((err) => {
          setIsLoadinig(false);
          console.log(err);
        });
    } else {
      amountEnter === "" ? ErrorToast("Enter Coins") : ErrorToast("Select Request/Coin Type");
    }
  };

  const onUserClick = (item) => {
    let url = `${endPoints.api.GET_BY_USERID}/${item.idUser}`;
    setIsLoadinig(true);
    getAllData(url)
      .then((response) => {
        setIsLoadinig(false);
        if (response?.status === "success") {
          setSelected(response?.data);
        }
      })
      .catch((err) => {
        setIsLoadinig(false);
        console.log(err);
      });
  };

  const seacrhUser = async () => {
    let url = `${endPoints.api.GET_ALL_USERS}?search=${searchQuery}`;
    setIsLoadinig(true);
    const result = await getAllData(url);
    setIsLoadinig(false);
    if (result?.status == "success") {
      setAllusers(result.data);
    }
  };

  const personalFacts = [
    ["Name", `${selected?.name || "—"} ${selected?.surname || ""}`],
    ["Email", selected?.email],
    ["Gender", selected?.sex],
    ["Date of Birth", selected?.birthDate],
    ["Language", selected?.language],
    ["Created On", selected?.insertionTime ? moment(selected.insertionTime).format("YYYY-MM-DD") : "—"],
    ...(showother
      ? [
          ["Document Type", selected?.documentTypeId],
          ["Document Number", selected?.documentId],
          ["Phone", selected?.phone],
          ["Mobile", selected?.mobile],
          ["Nation", selected?.nation],
          ["Country/State", selected?.country],
          ["Town", selected?.town],
          ["Address", selected?.address],
          ["Time Zone", selected?.timeZone],
        ]
      : []),
  ];

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <PageHeader
        title="Transfer"
        crumb="Finance / Transfer"
        subtitle="Deposit or withdraw player balances · manual adjustments"
      />

      <Grid container spacing={1.75}>
        <Grid item xs={12} lg={5}>
          <SectionCard title="Players" subtitle="Search and select a player">
            <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
              <TextField
                size="small"
                fullWidth
                placeholder="Username, ID, name or email"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && searchQuery !== "") seacrhUser();
                }}
              />
              <Button
                variant="contained"
                size="small"
                disabled={searchQuery == ""}
                onClick={seacrhUser}
                sx={{ textTransform: "none", flexShrink: 0 }}
              >
                Search
              </Button>
            </Box>

            <Box sx={{ maxHeight: 560, overflowY: "auto", border: `1px solid ${tokens.border}`, borderRadius: "10px" }}>
              {allusers.length === 0 && !isLoading && (
                <Typography sx={{ p: 2, fontSize: 12.5, color: tokens.textDim, textAlign: "center" }}>
                  No players found
                </Typography>
              )}
              {allusers.map((item) => {
                if (item.idUser != admin?.idUser && item.idUser != riskmng?.idUser) {
                  const isSelected = selected?.idUser === item.idUser;
                  return (
                    <Box
                      key={item.idUser}
                      onClick={() => onUserClick(item)}
                      sx={{
                        px: 1.75,
                        py: 1.1,
                        cursor: "pointer",
                        borderBottom: `1px solid ${tokens.border}`,
                        borderLeft: `3px solid ${isSelected ? tokens.primary : "transparent"}`,
                        background: isSelected ? tokens.hover : "transparent",
                        "&:hover": { background: "rgba(255,255,255,0.03)" },
                        "&:last-of-type": { borderBottom: "none" },
                      }}
                    >
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{item.login}</Typography>
                      <Typography sx={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                        #{item.idUser} · {item.email}
                      </Typography>
                    </Box>
                  );
                }
                return null;
              })}
            </Box>
          </SectionCard>
        </Grid>

        <Grid item xs={12} lg={7}>
          <Grid container spacing={1.75}>
            <Grid item xs={12}>
              <SectionCard
                title="Player details"
                subtitle="Personal information & balances"
                action={
                  selected?.type != null ? pill(userTypeLabel(selected?.type), statusKind("active")) : null
                }
              >
                <Grid container spacing={1.75} sx={{ mb: 1.75 }}>
                  <Grid item xs={6} md={3}>
                    <MiniStat
                      label="Gold Coin"
                      value={`${selected?.account?.gc_balance ?? 0}`}
                      color={tokens.accent}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <MiniStat
                      label="Saga Coin"
                      value={`${selected?.account?.sc_credit ?? 0}`}
                      color={tokens.secondary}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <MiniStat
                      label="Redeem Saga Coin"
                      value={`${selected?.account?.sc_main ?? 0}`}
                      color={tokens.primary}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <MiniStat
                      label="Total Saga Coin"
                      value={`${sumSC_credit_SC_Main(
                        selected?.account?.sc_credit,
                        selected?.account?.sc_main
                      )}`}
                      color={tokens.blue}
                    />
                  </Grid>
                </Grid>

                <FactRows facts={personalFacts} />
                <Button
                  size="small"
                  variant="outlined"
                  color="inherit"
                  onClick={() => setShowOther(!showother)}
                  sx={{ textTransform: "none", color: tokens.textDim, borderColor: tokens.border }}
                >
                  {showother ? "Show less" : "Show more"}
                </Button>
              </SectionCard>
            </Grid>

            <Grid item xs={12}>
              <SectionCard title="Transfer" subtitle="Move funds to or from the selected player">
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                    <FormControl>
                      <FormLabel sx={groupLabelSx}>Coin Type</FormLabel>
                      <RadioGroup row value={type} onChange={(e) => setType(e.target.value)}>
                        <FormControlLabel
                          value="gc_balance"
                          control={<Radio size="small" />}
                          label={`Gold Coin (${selected?.account?.gc_balance || 0})`}
                          sx={radioSx}
                        />
                        <FormControlLabel
                          value="sc_credit"
                          control={<Radio size="small" />}
                          label={`Saga Coin (${selected?.account?.sc_credit || 0})`}
                          sx={radioSx}
                        />
                        <FormControlLabel
                          value="sc_main"
                          control={<Radio size="small" />}
                          label={`Redeem Saga Coin (${selected?.account?.sc_main || 0})`}
                          sx={radioSx}
                        />
                      </RadioGroup>
                    </FormControl>

                    <FormControl>
                      <FormLabel sx={groupLabelSx}>Request Type</FormLabel>
                      <RadioGroup row value={requestType} onChange={(e) => setRequestType(e.target.value)}>
                        <FormControlLabel value="Deposit" control={<Radio size="small" />} label="Deposit" sx={radioSx} />
                        <FormControlLabel value="WithDraw" control={<Radio size="small" />} label="Withdraw" sx={radioSx} />
                      </RadioGroup>
                    </FormControl>
                  </Box>

                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                    <TextField
                      size="small"
                      label="Coins"
                      placeholder="0.00"
                      value={amountEnter}
                      onChange={handleAmountChange}
                      sx={{ width: 160 }}
                      inputProps={{ style: { fontFamily: mono } }}
                    />
                    <TextField
                      size="small"
                      label="Description"
                      placeholder="Reason for adjustment"
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                      sx={{ flexGrow: 1, minWidth: 220 }}
                    />
                  </Box>

                  <Box>
                    <Button
                      variant="contained"
                      disabled={selected?.idUser ? false : true}
                      onClick={WithdrawDeposit}
                      sx={{ textTransform: "none", fontWeight: 600 }}
                    >
                      Perform {requestType === "Deposit" ? "Deposit" : "Withdrawal"}
                    </Button>
                    {selected?.idUser ? (
                      <Typography variant="caption" color="text.secondary" sx={{ ml: 1.5 }}>
                        to {selected?.name} {selected?.surname} (#{selected?.idUser})
                      </Typography>
                    ) : (
                      <Typography variant="caption" color="text.secondary" sx={{ ml: 1.5 }}>
                        select a player first
                      </Typography>
                    )}
                  </Box>
                </Box>
              </SectionCard>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Transfer;
